import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './setupWarningFilter'; // Suppress known third-party library warnings
import './assets/bootstrap/css/bootstrap.min.css';
import './assets/css/master.css';
import './assets/custom.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './providers/AuthProvider';
import React, { useState, useEffect } from 'react';
import './assets/kendo-grid-override.css';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { Spinner } from 'react-bootstrap';

const Index = () => {
    const [authConfig, setAuthConfig] = useState(null);

    useEffect(() => {
        const storedAuthConfig = localStorage.getItem('authConfig');

        if (storedAuthConfig) {
            var config = JSON.parse(storedAuthConfig);
            setAuthConfig(config);

            if (config.appInsightConnectionString) {
                var reactPlugin = new ReactPlugin();
                const appInsights = new ApplicationInsights({
                    config: {
                        extensions: [reactPlugin],
                        enableAutoRouteTracking: true,
                        connectionString: config.appInsightConnectionString
                    }
                });
                appInsights.loadAppInsights();
                appInsights.trackPageView();
                // Optionally, you can track custom telemetry
                appInsights.trackEvent({ name: 'YourCustomEvent', properties: { customProperty: 'CustomValue' } });
            }
        } else {
            fetch('/api/oidcconfiguration')
                .then(response => response.json())
                .then(data => {
                    localStorage.setItem('authConfig', JSON.stringify(data));
                    localStorage.setItem('accessTokenVariable', `oidc.user:${data.authServerUrl}:${data.clientId}`);
                    setAuthConfig(data);
                })
                .catch(error => {
                    console.error('Error fetching auth config:', error);
                    setAuthConfig(null);
                });
        }
    }, []); // Only run once on initial render
    return (
        <div>
            {authConfig ? (
                <AuthProvider>
                    <BrowserRouter
                        future={{
                            v7_startTransition: true,
                            v7_relativeSplatPath: true
                        }}
                    >
                        <App />
                    </BrowserRouter>
                </AuthProvider>
            ) : (
                <div className="loader-backdrop">
                    <Spinner animation="border" variant="primary" />
                </div>
            )}
        </div>
    );
};


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Index />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
